import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { Flex, Box } from 'reflexbox'
import Link from 'react-toolbox/lib/link'

import FilterNavHeader from './FilterNavHeader'
import FilterMenuHeader from './FilterMenuHeader'
import Divider from 'components/fulcrum/divider/Divider'
import Collapse from 'components/fulcrum/collapse/Collapse'
import {
  FilterType
} from './constants'

import theme from './FilterMenu.scss'

class FilterMenu extends Component{
  static propTypes = {
    changeFilter: PropTypes.func.isRequired,
    getApprovals: PropTypes.func.isRequired,
    filter: PropTypes.string.isRequired,
  }

  static defaultProps = {
    filter: FilterType.ALL.value
  }

  state = { collapse: true }

  toggleCollapse = () => this.setState({ ...this.state, collapse: !this.state.collapse })

  changeFilter = (type) => {
    const { changeFilter } = this.props
    return () => changeFilter(type)
  }

  createLinks(){
    const { changeFilter, filter } = this.props
    return Object.values(FilterType)
      .map(({ label, value }) => (
        <Link
          key={label}
          label={label}
          onClick={ this.changeFilter(value) }
          active={filter === value}
          theme={theme}
        />
      ))
  }

  render(){
    return (
      <div>
        <FilterMenuHeader
          toggle={ () => this.toggleCollapse() }
          getApprovals={ this.props.getApprovals }
        />
        <Collapse collapse={this.state.collapse}>
          <FilterNavHeader>
            { this.createLinks() }
          </FilterNavHeader>
        </Collapse>
        <Divider styleName='divider'/>
      </div>
    )
  }
}

export default CSSModules(FilterMenu, theme)
